module.exports = __webpack_public_path__ + "img/home-hero-bg.1656dc52.png";